import { useMutation } from '@apollo/client';
import { Button, Fields, Link } from '@ets-global/b2c-website-ui';
import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Trans, useTranslation } from 'react-i18next';

import TinyText from '../../components/Base/Text/TinyText/TinyText';
import HeaderMeta from '../../components/HeaderMeta';
import FormLayout from '../../components/Layout/Form/FormLayout';
import { FORGOTTEN_PASSWORD } from '../../graphql/mutations';
import useYup from '../../hooks/useYup';
import { paths } from '../../paths';

const ForgottenPassword = () => {
  const { t } = useTranslation();
  const { Yup } = useYup();
  const [forgottenPassword] = useMutation(FORGOTTEN_PASSWORD);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();

  const validationSchema = Yup.object().shape({
    email: Yup.string().required().email(),
  });

  const onSubmit = async (data, actions) => {
    if (!executeRecaptcha) {
      return;
    }

    const recaptchaToken = await executeRecaptcha('b2c_website_forgot_password');

    forgottenPassword({
      variables: {
        email: data.email,
        recaptchaToken,
      },
    });

    setIsSubmitted(true);

    actions.setSubmitting(false);
  };

  return (
    <>
      <HeaderMeta page={'forgotten-password'} meta={{}} />
      <FormLayout title={t('forgotten-password.title')} subtitle={!isSubmitted ? t('forgotten-password.subtitle') : ''}>
        {!isSubmitted ? (
          <>
            <Formik
              initialValues={{ email: '' }}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
              render={() => (
                <Form>
                  <Fields.FormikFastField
                    id={'email'}
                    name={'email'}
                    component={Fields.TextField}
                    label={<Trans>forgotten-password.form.label.email</Trans>}
                    autoComplete={'email'}
                    required={true}
                  />
                  <Button type="submit" className="button--full" aria-label={t('forgotten-password.form.label.send')}>
                    <Trans>forgotten-password.form.label.send</Trans>
                  </Button>
                </Form>
              )}
            />
            <div className={'form-layout__continue'}>
              <Link
                className={'link--reversed'}
                to={paths.LOGIN}
                data-cypress="login-link"
                icon={'arrow'}
                aria-label={t('forgotten-password.link-to-login')}
              >
                <Trans>forgotten-password.link-to-login</Trans>
              </Link>
            </div>
          </>
        ) : (
          <>
            <TinyText>
              <Trans>forgotten-password.text-on-submit</Trans>
            </TinyText>
            <Button
              to={paths.LOGIN}
              aria-label={t('forgotten-password.login')}
              data-cypress="login-link"
              className={'button--full'}
            >
              <Trans>forgotten-password.login</Trans>
            </Button>
          </>
        )}
      </FormLayout>
    </>
  );
};

export default ForgottenPassword;
